import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgBenefitViral = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 64,
	height: 64,
	viewBox: "0 0 64 64",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	"aria-hidden": "true",
	...props,
	children: [/* @__PURE__ */ _jsx("rect", {
		width: 64,
		height: 64,
		fill: "#1E1E1E"
	}), /* @__PURE__ */ _jsxs("g", {
		id: "Friends with Benefits - Welcome Screen",
		children: [
			/* @__PURE__ */ _jsx("path", {
				d: "M-1436 -1039C-1436 -1149.46 -1346.46 -1239 -1236 -1239H6250C6360.46 -1239 6450 -1149.46 6450 -1039V2358C6450 2468.46 6360.46 2558 6250 2558H-1236C-1346.46 2558 -1436 2468.46 -1436 2358V-1039Z",
				fill: "#252525"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M-1236 -1239V-1238H6250V-1239V-1240H-1236V-1239ZM6450 -1039H6449V2358H6450H6451V-1039H6450ZM6250 2558V2557H-1236V2558V2559H6250V2558ZM-1436 2358H-1435V-1039H-1436H-1437V2358H-1436ZM-1236 2558V2557C-1345.9 2557 -1435 2467.9 -1435 2358H-1436H-1437C-1437 2469.01 -1347.01 2559 -1236 2559V2558ZM6450 2358H6449C6449 2467.9 6359.9 2557 6250 2557V2558V2559C6361.01 2559 6451 2469.01 6451 2358H6450ZM6250 -1239V-1238C6359.9 -1238 6449 -1148.9 6449 -1039H6450H6451C6451 -1150.01 6361.01 -1240 6250 -1240V-1239ZM-1236 -1239V-1240C-1347.01 -1240 -1437 -1150.01 -1437 -1039H-1436H-1435C-1435 -1148.9 -1345.9 -1238 -1236 -1238V-1239Z",
				fill: "white",
				fillOpacity: .1
			}),
			/* @__PURE__ */ _jsxs("g", {
				id: "Friends with Benefits - Registrieren - Mobile",
				children: [/* @__PURE__ */ _jsx("rect", {
					width: 390,
					height: 3526,
					transform: "translate(-163 -1015)",
					fill: "white"
				}), /* @__PURE__ */ _jsx("g", {
					id: "Frame 17",
					children: /* @__PURE__ */ _jsx("g", {
						id: "Frame 16",
						children: /* @__PURE__ */ _jsxs("g", {
							id: "section-configurator",
							children: [/* @__PURE__ */ _jsx("rect", {
								width: 390,
								height: 1024,
								transform: "translate(-163 -751)",
								fill: "#F9F5F0"
							}), /* @__PURE__ */ _jsxs("g", {
								id: "section-stage",
								children: [/* @__PURE__ */ _jsx("rect", {
									width: 358,
									height: 675,
									transform: "translate(-147 -450)",
									fill: "#F9F5F0"
								}), /* @__PURE__ */ _jsx("g", {
									id: "benefit-container",
									children: /* @__PURE__ */ _jsxs("g", {
										id: "sl-likes",
										children: [/* @__PURE__ */ _jsx("path", {
											id: "Color",
											d: "M54.0136 15C54.8395 15.0001 55.6317 15.3281 56.2157 15.9121L59.1962 18.8936C60.4461 20.1432 59.69 38.949 59.3427 46.3242C59.2648 47.9771 57.9007 49.2606 56.246 49.2607H37.9061C37.0801 49.2607 36.2881 49.5888 35.704 50.1729L31.4882 54.3887C30.8801 54.9966 29.8941 54.9965 29.286 54.3887L25.0702 50.1729C24.4862 49.5888 23.694 49.2608 22.8681 49.2607H7.64247C5.98775 49.2607 4.62363 47.9771 4.54579 46.3242C4.19846 38.949 3.44237 20.1432 4.69227 18.8936L7.67274 15.9121C8.25675 15.3282 9.04903 15.0001 9.87489 15H54.0136ZM25.0038 25.207C21.7669 24.258 20.0662 26.7646 19.5126 28.8516C18.9329 26.5476 17.2332 24.3501 14.0018 25.2246C12.0098 25.7638 11 28.3574 10.9999 30.6436C10.9999 33.0704 12.2748 34.8645 13.5497 36.4473L18.83 41.3643C19.2146 41.7222 19.8105 41.7212 20.1942 41.3623L25.4501 36.4473C26.725 34.8645 27.9999 33.0598 27.9999 30.6436C28.0086 28.3523 26.989 25.7894 25.0038 25.207Z",
											fill: "#FF6047"
										}), /* @__PURE__ */ _jsx("path", {
											id: "Black",
											d: "M58.0557 45.0303C58.0557 46.3044 57.0231 47.3377 55.749 47.3379H44.8477V45.8379H55.749C56.1947 45.8377 56.5557 45.476 56.5557 45.0303V32.5723H58.0557V45.0303ZM50.3545 27.7559H44.1729L43.7549 31.9141C44.0481 31.6648 44.4293 31.4669 44.8984 31.3203C45.3824 31.1736 45.889 31.1006 46.417 31.1006C47.3407 31.1006 48.1692 31.3053 48.9023 31.7158C49.6503 32.1265 50.2446 32.7061 50.6846 33.4541C51.1246 34.2021 51.3447 35.0895 51.3447 36.1162C51.3447 36.8495 51.2054 37.5315 50.9268 38.1621C50.6481 38.7781 50.2662 39.3207 49.7822 39.79C49.2984 40.2445 48.734 40.5964 48.0889 40.8457C47.4436 41.095 46.7469 41.2197 45.999 41.2197C45.075 41.2197 44.2236 41.0512 43.4463 40.7139C42.6838 40.3619 42.0533 39.863 41.5547 39.2178C41.0708 38.5578 40.7921 37.7803 40.7188 36.8857H43.0068C43.1095 37.2964 43.2926 37.6637 43.5566 37.9863C43.8353 38.3089 44.1802 38.5584 44.5908 38.7344C45.0161 38.9103 45.4858 38.998 45.999 38.998C46.4095 38.998 46.7985 38.9249 47.165 38.7783C47.5315 38.6317 47.8465 38.426 48.1104 38.1621C48.389 37.8834 48.6024 37.5678 48.749 37.2158C48.9102 36.8493 48.9902 36.4603 48.9902 36.0498C48.9902 35.4633 48.8586 34.9428 48.5947 34.4883C48.3307 34.0336 47.9713 33.6742 47.5166 33.4102C47.0767 33.1462 46.5709 33.0137 45.999 33.0137C45.471 33.0137 44.9791 33.1023 44.5244 33.2783C44.0699 33.4543 43.7034 33.7038 43.4248 34.0264H41.4229L42.127 25.6006H50.3545V27.7559ZM38.248 41H35.96V28.7461L32.4619 31.6279V28.8564L36.6416 25.6006H38.248V41ZM58.291 9.09668L59.0088 9.31152L57.5674 14.1328L60.6826 13.6016L60.9346 15.0801L57.6846 15.6338L59.501 18.7295L58.8545 19.1084L58.208 19.4883L56.7236 16.959L55.4238 21.3115L53.9863 20.8818L55.4395 16.0176L51.9346 16.6162L51.6826 15.1377L55.293 14.5205L53.502 11.4678L54.7949 10.708L56.2734 13.2275L57.5723 8.88184L58.291 9.09668ZM26.5 21.25H8V19.75H26.5V21.25ZM34.5 21.25H29.5V19.75H34.5V21.25ZM42.3721 5.0791L43.6299 3.125L44.8916 3.93555L43.4951 6.10645L45.9824 6.7002L45.6348 8.15918L43.7236 7.70312L45.2939 10.7529L43.96 11.4404L42.2285 8.07715L40.79 10.3154L40.1592 9.90918L39.5283 9.50391L41.0889 7.0752L38.6348 6.49023L38.9824 5.03125L40.8955 5.4873L39.3271 2.44043L39.9941 2.09668L40.6602 1.75293L42.3721 5.0791Z",
											fill: "#311123"
										})]
									})
								})]
							})]
						})
					})
				})]
			})
		]
	})]
});
export default SvgBenefitViral;
